export default __webpack_public_path__ + "static/media/activePortfolio.cb82b30c.svg";